module.exports = __webpack_public_path__ + "img/expired.8b497e65.svg";